import React, { Fragment } from "react";

const realizeprevIcon = require("../../assets/images/realizeprev.webp");

const fachesfIcon = require("../../assets/images/fachesf.webp");

function Header() {
  return (
    <Fragment>
      <header>
        <div className="wrapper">
          <a href="javascript:history.back()" title="Voltar">
            Voltar
          </a>
          <img
            src={realizeprevIcon}
            alt="RealizePrev"
            className="realizeprev"
          />
          <img src={fachesfIcon} alt="Fachesf" className="fachesf" />
        </div>
      </header>
    </Fragment>
  );
}
export default Header;
